import {css} from '@emotion/react'
import {colors} from '../../../constants'
import EmailArrow from '../../../images/browser/email-arrow.svg'

const Email = () => {
    return (
        <div className="email">
            <form
                action="#todo"
                css={css`
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 100%;
                    border: 1px solid ${colors.midnightMedium};
                    max-width: 291px;
                    padding: 10px;
                    border-radius: 53px;
                    @media (max-width: 800px) {
                        width: calc(100vw - 84px);
                        max-width: 100%;
                    }
                `}
            >
                <input
                    type="text"
                    placeholder="Enter email"
                    css={css`
                        font-size: 14px;
                        border: none;
                        margin-left: 12px;
                        color: ${colors.midnight};
                        &::placeholder {
                            color: ${colors.midnightMedium};
                        }
                        &:focus {
                            outline: none;
                        }
                    `}
                />
                <button
                    type="submit"
                    label="send email"
                    css={css`
                        background: transparent;
                        border: none;
                        padding: 0;
                        &:hover {
                            cursor: pointer;
                        }
                    `}
                >
                    <EmailArrow />
                </button>
            </form>
        </div>
    )
}

export default Email
